import React, { useState, useEffect } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import { Modal, Space } from 'antd';
import { useBnsJiaoChengKeShiUpdateQuery } from '../../store/ReactWebSiteApi';
function CourseCheck(props) {
    const [open,setOpen] = useState(false)  
    const [info,setInfo] = useState({
        bjcks_content:'',
    })
    const {data,isSuccess} = useBnsJiaoChengKeShiUpdateQuery({bjcks_id:props.bjcks_id},{skip:!props.bjcks_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    bjcks_content:data.Result.bjcks_content,
                    bjcks_dept_id:data.Result.bjcks_dept_id,        
                    bjcks_dept_name:data.Result.bjcks_dept_name,        
                    bjcks_bg_name:data.Result.bjcks_bg_name,        
                    bjcks_name:data.Result.bjcks_name,  
                    bjcks_ctime:data.Result.bjcks_ctime,                                       
                    bjcks_cname:data.Result.bjcks_cname,                                       
                    bjcks_num:data.Result.bjcks_num,                                                
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])  
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bjcks_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <h2>{info.bjcks_name}</h2>              
                <p dangerouslySetInnerHTML={{__html:info.bjcks_content}}></p>
            </Modal>
        </>
    )
}

export default CourseCheck